<div class="inventory">
  <div class="inventory__header">
    <div class="inventory__title">
      <svg-icon
        class="flex items-center justify-center s-16 icon-yellow"
        src="assets/icons/updater/inventory.svg"
        [applyClass]="true"
      />
      <span>Inventory</span>
    </div>

    <div class="inventory__header-actions">
      <app-checkbox
        [(checked)]="showPureSkins"
        (checkedChange)="onPureToggle($event)"
        [disabled]="upgraderService.state() !== 'idle'"
      >
        <span class="inventory__checkbox-label">Show Pure Skins</span>
      </app-checkbox>
    </div>
  </div>

  <div class="inventory__controls">
    <app-search-input
      [query]="search()"
      (queryChange)="onSearchChange($event)"
      [disabled]="isLoading() || upgraderService.state() !== 'idle'"
    />

    <div class="inventory__buttons">
      <button
        class="button inventory__btn"
        (click)="onDeposit()"
        [disabled]="upgraderService.state() !== 'idle'"
      >
        Deposit
        <svg-icon
          class="flex items-center justify-center s-12 icon-yellow"
          src="assets/icons/ui/plus.svg"
          [applyClass]="true"
        />
      </button>

      <button
        class="button button--style-secondary inventory__btn"
        (click)="onWithdraw()"
        [disabled]="upgraderService.state() !== 'idle' || !selectedSkins().length || isWithdrawing()"
      >
        <svg-icon
          class="flex items-center justify-center s-16 icon-gray"
          src="assets/icons/updater/withdraw.svg"
          [applyClass]="true"
        />
        Withdraw
      </button>

      <button
        class="button button--style-secondary inventory__btn"
        (click)="onSell()"
        [disabled]="upgraderService.state() !== 'idle' || !selectedSkins().length || isSelling()"
      >
        <svg-icon
          class="flex items-center justify-center s-12 icon-gray"
          src="assets/icons/core/price.svg"
          [applyClass]="true"
        />
        Sell
      </button>
        <button
                class="button button--style-secondary inventory__btn"
                (click)="refreshInventory()"
                [disabled]="isLoading() || isRefreshing() || upgraderService.state() !== 'idle'"
        >
            <svg-icon
                    class="flex items-center justify-center s-16 icon-gray"
                    src="assets/icons/ui/refresh.svg"
                    [applyClass]="true"
                    [@rotateRefreshAnimation]="isRefreshing() ? 'active' : 'inactive'"
            />
        </button>
    </div>

    <app-toggle
      [title]="'Sort by'"
      [value]="currentSort().label"
      (handleClick)="toggleSort()"
      [arrowPosition]="currentSort().key === 'highest_price' ? 'top' : 'down'"
      [disabled]="isLoading() || upgraderService.state() !== 'idle'"
    />
  </div>

  <div class="inventory__content" [class.inventory__content--disabled]="upgraderService.state() !== 'idle'">
      @if (isLoading() && !isRefreshing()) {
      <div class="inventory__state inventory__state--loading">
        <app-loading-icon color="var(--yellow)" size="48px" />
      </div>
    } @else if (error()) {
      <div class="inventory__state inventory__state--error">
        <p>{{ error() }}</p>
        <button
          class="button button--style-primary"
          (click)="refreshInventory()"
        >
          Retry
        </button>
      </div>
    } @else if (displayedSkins().length === 0) {
      <div class="inventory__state inventory__state--empty">
        <div class="inventory__empty-icon">
          <svg-icon
            class="flex items-center justify-center s-64 icon-gray"
            src="assets/icons/updater/empty-inventory.svg"
            [applyClass]="true"
          />
        </div>
        <h3>You have no available items yet</h3>
        <p>Your inventory is empty, click on the deposit button below</p>
        <button
          class="button inventory__btn"
          (click)="onDeposit()"
        >
          Deposit
          <svg-icon
            class="flex items-center justify-center s-12 icon-yellow"
            src="assets/icons/ui/plus.svg"
            [applyClass]="true"
          />
        </button>
      </div>
    } @else {
      <app-skins-list
        class="inventory__grid"
        [skins]="paginatedSkins()"
        [config]="gridConfig()"
        [selectable]="true"
        [(selectedSkins)]="selectedSkins"
        [balanceType]="'skins'"
      />
    }

    @if (totalPages() > 1) {
      <app-table-pagination
        class="inventory__pagination"
        [currentPage]="pageIndex() + 1"
        [pageCount]="totalPages()"
        [disabledPreviousPage]="pageIndex() === 0"
        [disabledNextPage]="pageIndex() >= totalPages() - 1"
        [showFirstPage]="false"
        [showLastPage]="false"
        (handlePreviousPage)="prevPage()"
        (handleNextPage)="nextPage()"
      />
    }
  </div>
</div>
